<template>
    <div>
        <div class="columns mx-0 mb-0 mt-1">
            <div
                class="column is-two-fifths-desktop p-0"
                :class="{'is-one-third-fullhd': !isFullScreenTest, 'is-one-fifth-fullhd': isFullScreenTest}"
            >
                <label class="label" for="test-name-input">
                    {{ trans.edit_form.random_order_answers_label }}
                </label>
            </div>
            <div
                class="column p-0 control has-icons-right align-center"
            >
                <toggle-button
                    :is-disabled="requestsProgress.question.updateSettings || !isCanEdit"
                    v-model="question.settings.is_random_order"
                />
            </div>
        </div>
        <div class="columns mx-0 mb-0 mt-1">
            <div
                class="column is-two-fifths-desktop p-0"
                :class="{'is-one-third-fullhd': !isFullScreenTest, 'is-one-fifth-fullhd': isFullScreenTest}"
            >
                <label class="label" for="test-name-input">
                    {{ trans.edit_form.required_question_label }}
                </label>
            </div>
            <div
                class="column p-0 control has-icons-right align-center"
            >
                <toggle-button
                    :is-disabled="requestsProgress.question.updateSettings || !isCanEdit"
                    v-model="question.settings.is_required"
                />
            </div>
        </div>
        <div class="columns mx-0 mb-0 mt-1">
            <div
                class="column is-two-fifths-desktop p-0"
                :class="{'is-one-third-fullhd': !isFullScreenTest, 'is-one-fifth-fullhd': isFullScreenTest}"
            >
                <label class="label" for="test-name-input">
                    {{ trans.edit_form.is_has_points_label }}
                </label>
            </div>
            <div
                class="column p-0 control has-icons-right align-center"
            >
                <toggle-button
                    :is-disabled="requestsProgress.question.updateSettings || !isCanEdit"
                    v-model="question.settings.is_has_points"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ToggleButton from "../../../../../utils/forms/ToggleButton";
import {mapActions, mapGetters} from "vuex";
export default {
    name: "QuestionParametersTabForm",
    components: {ToggleButton},
    props: {
        question: Object,
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'requestsProgress',
            'isFullScreenTest',
            'isCanEdit',
        ])
    },
    watch: {
        'question.settings.is_random_order': function () {
            this.save();
        },
        'question.settings.is_required': function () {
            this.save();
        },
        'question.settings.is_has_points': function () {
            this.save();
        },
    },
    methods: {
        ...mapActions('tests', [
            'updateTestQuestionSettings'
        ]),
        save() {
            this.updateTestQuestionSettings({
                questionId: this.question.hash_id,
                settings: this.question.settings,
            });
        },
    }
}
</script>